import { render } from "./LearnerProtection.vue?vue&type=template&id=55c457e4"
import script from "./LearnerProtection.vue?vue&type=script&lang=js"
export * from "./LearnerProtection.vue?vue&type=script&lang=js"

import "./LearnerProtection.vue?vue&type=style&index=0&id=55c457e4&lang=css"

import exportComponent from "E:\\Projects\\Ned-ie\\ned_website-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__